import { SubscriptionSlideItemDraft, FileFormat } from "../../types";
import { DefaultSchedule } from "../../components/SubscriptionsSettings/SubscriptionsSettingsSchedule";

export const InitialItemDraft: Omit<SubscriptionSlideItemDraft, "payload" | "type"> = {
  name: "",
  fileFormat: FileFormat.XLSX,
  schedule: DefaultSchedule,
};
